<template>
  <div class="content-wrapper step-1">
    <div class="step-wrapper">
      <div class="form-wrapper">
        <YuzuAiBanner />
        <i class="yuzu-icon yuzu-ai" />

        <div class="content">
          <span class="title">Patientez quelques instants</span>
          <br />
          <span class="yuzuai">Yuzu AI</span> est en train d’analyser le métier choisi... Vous allez découvrir les
          compétences les plus importantes à évaluer d‘ici quelques secondes !
          <Loader :showLock="false" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.yuzu-icon.yuzu-ai {
  width: 48px;
  height: 48px;
}

.content {
  text-align: center;

  color: #FFF;
  font-size: 16px;
  font-weight: 400;
  line-height: normal;

  .title {
    text-align: center;
    font-size: 32px;
    font-weight: 700;
  }

  .loader {
    margin: auto;
    margin-top: 8px;
    height: 48px;
    align-items: initial;
  }
}
</style>

<script setup lang="ts">
import { onMounted, reactive } from "vue";
import { useRoute, onBeforeRouteLeave } from "vue-router";
import { useAppStore } from "@/stores/app.js";
import YuzuAiBanner from "./YuzuAiBanner.vue";

export interface AISkill {
  name: string;
}

export interface AISkillJob {
  job_title: string;
  skills: {
    required: AISkill[]; // mandatory
    mandatory: AISkill[]; // empty
    primary: AISkill[]; // important
    important: AISkill[]; // empty
    secondary: AISkill[];
    ignored: AISkill[];
  };
}

export interface AISkillsResult {
  query: string;
  results: AISkillJob[];
}

const emits = defineEmits(["next"]);

const appStore = useAppStore();

const route = useRoute();

const props = defineProps({
  campaignData: {
    type: Object,
  },
});

const state = reactive({
  workspace_id: props.campaignData.workspace_id,
});

if (!appStore.isOnboarded) {
  onBeforeRouteLeave((to, from, next) => {
    if (appStore.chapterState.isComplete) {
      window.confirm("Souhaitez-vous vraiment quitter l'onboarding ?")
        ? (next(), (appStore.isOnboarded = true))
        : false;
    }
  });
}

async function GetData(job): Promise<AISkillsResult> {
  const response = await useAxios.get<AISkillsResult>(`/companies/${route.params.companyId}/skills?job=${job}&version=2`);
  const data: AISkillsResult = response.data;
  // Fix the data: Convert required to mandatory, and primary to important and put first letter uppercase
  data.results.forEach((result) => {
    result.skills.mandatory = result.skills.required;
    result.skills.important = result.skills.primary;

    // Capitalize the first letter of each skill
    result.job_title = result.job_title.charAt(0).toUpperCase() + result.job_title.slice(1);
  });
  return data;
}

onMounted(async () => {
  if (route.query.spaceId) {
    state.workspace_id = route.query.spaceId;
  }

  if (props.campaignData.job) {
    const job = props.campaignData.job;
    try {
      const jobInfo = await GetData(job);
      emits("next", { ...props.campaignData, jobInfo });
    } catch (error) {
      console.error("Error fetching job data:", error);
      emits("next", { ...props.campaignData, jobInfo: null });
    }
  } else emits("next", props.campaignData);
});
</script>
